import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import styled, { keyframes } from 'styled-components';
import Header from './components/Header';
import Liquid from './components/Liquid';
import Projects from './components/Projects';
import Home from './components/Home';
import KeywordResearch from './components/KeywordResearch';
import BackgroundEffect, { Gradient } from './components/BackgroundEffect';
import CompetitionResearch from './components/CompetitionResearch';
import { useCallback, useEffect, useRef, useState } from 'react';
import GoogleSearch from './components/GoogleSearch';
import BingSearch from './components/BingSearch';
import TopSearchQueries from './components/TopSearchQueries';
import IndexedPages from './components/IndexedPages';
import Sitemaps from './components/Sitemaps';
import CrawlabilityTest from './components/CrawlabilityTest';
import MobileSupportTest from './components/MobileSupportTest';
import HeadersTest from './components/HeadersTest';
import SpeedTest from './components/SpeedTest';
import LinkAnalysis from './components/LinkAnalysis';
import KeywordDensity from './components/KeywordDensity';
import ExtractMetaTags from './components/ExtractMetaTags';
import NewBacklinks from './components/NewBacklinks';
import LowQualityBacklinks from './components/LowQualityBacklinks';
import TopReferrers from './components/TopReferrers';
import PageAuthority from './components/PageAuthority';
import DomainAuthority from './components/DomainAuthority';
import HighQualityBacklinks from './components/HighQualityBacklinks';
import KeywordProject from './components/KeywordProject';
import CompetitionProject from './components/CompetitionProject';
import { useDispatch, useSelector } from 'react-redux';
import BacklinkProfileProject from './components/BacklinkProfileProject';
import Register from './components/Register';
import { auth, db } from './firebase';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { injectUser } from './Redux/userSlice';
import { onAuthStateChanged } from 'firebase/auth';
import { updateProjects } from './Redux/projectsSlice';
import PRoute from './components/PRoute';
import Login from './components/Login';
import Upgrade from './components/Upgrade';
import Store from './components/Store';
import MRoute from './components/MRoute';
import Nex20 from './media/free20.gif'
import { base } from './utils';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import PageLoad from './components/PageLoad';
import TrackPageViews from './TrackPageViews';
import emptyNex from './media/empty-nex.png'
import { setNexil } from './Redux/nexSlice';
import Root from './components/Root';
import ForgotPassword from './components/ForgotPassword';
import { debounce } from 'lodash';



function App() {
  const bgPath = useSelector(state=> state.bgEffect.bgPath)
  const [key, setKey] = useState(0); // State to trigger re-render
  const [projListn, setProjListn] = useState(0);
  const [nexListn, setNexListn] = useState(0);
  const [userListn, setUserListn] = useState(0);
  const [isAuth, setIsAuth] = useState(false)
  const [nex, setNex] = useState(null)
  const [settingsPath, setSettingsPath] = useState('acc-stats')
  const [toolsStates, setToolsStates] = useState(null)
  const [intr, setIntr] = useState(false)
  const [ann, setAnn] = useState('')
  const [cancelInuPop, setCancelInuPop] = useState(false)
  const [dataStructureReady, setDataStructureReady] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [debouncedProjects, setDebouncedProjects] = useState(null);

  const [sWidth, setSWidth] = useState(window.innerWidth)


  const user = useSelector(state=> state.user.user)
  const projects = useSelector(state=> state.projects.projects)
  const nx = useSelector(state=> state.nex.nex)

  const forceRerender = () => {
    setKey(prevKey => prevKey + 1);
  };

  const dispatch = useDispatch()

  const cPath = window.location.pathname?.split('/').pop()

  // const [cPath, setCPath] = useState(null)
  // useEffect(()=> {
  //   setCPath(window.location.pathname?.split('/').pop())
  // }, [key])

  const updateINUZero = async () => {
    if(Number(user.inuNot) == 0) {
      await updateDoc(doc(db, 'users', user.id), {inuNot: 1})
      setCancelInuPop(true)
    }
  }

  const updateINUNotZero = async () => {
    await updateDoc(doc(db, 'users', user.id), {inuNot: 0})
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch nex data
        const nexResponse = await fetch(`${base}/nex`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId: user.id,
            userEmail: user.email
          })
        });
  
        const nexData = await nexResponse.json();
  
        if (nexData.message) {
          setNex(0);
          updateINUZero();
          await updateDoc(doc(db, 'users', user.id), { nex: 0 }); // Update nex in Firestore
          dispatch(setNexil(0));
        } else {
          setNex(nexData);
          updateINUNotZero();
          await updateDoc(doc(db, 'users', user.id), { nex: nexData }); // Update nex in Firestore
          dispatch(setNexil(nexData));
        }
  
        // Fetch units data
        const unitsResponse = await fetch(`${base}/units`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId: user.id,
            userEmail: user.email
          })
        });
  
        const unitsData = await unitsResponse.json();
        updateDoc(doc(db, 'users', user.id), { units: unitsData }); // Update units in Firestore
  
        // Fetch subscription status
        // const subscriptionResponse = await fetch(`${base}/subscription-status`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify({
        //     sid: user.sid,
        //     userId: user.id
        //   })
        // });
  
        // const subscriptionData = await subscriptionResponse.json();
        // if (subscriptionData.status === 'ACTIVE') {
        //   await updateDoc(doc(db, 'users', user.id), { prem: true }); // Update prem and sid in Firestore
        // } else {
        //   await updateDoc(doc(db, 'users', user.id), { prem: false, sid: null }); // Update prem and sid in Firestore
        // }
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    if (user) {
      fetchData();
    }
  }, [user]);
  



  // useEffect(()=> {
  //   if(nx) {
  //     const updateNex = async (x) => {
  //       await updateDoc(doc(db, 'users', user.id), {nex: x})
  //     }

  //     updateNex(nx)
  //   }
  // }, [nx])




  useEffect(()=> {
    const getAnn = async () => {
      let data = await getDoc(doc(db, 'announcements', 'announcement'))
      if(data) setAnn(data.data().body)
    }

    getAnn()
  }, [])



  // useEffect(() => {
  //     if(user) {
  //       const updateUnits = async (newUnits) => {
  //         await updateDoc(doc(db, 'users', user.id), {units: newUnits})
  //       }

  //       fetch(`${base}/units`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({
  //         userId: user.id,
  //         userEmail: user.email
  //       })
  //     })
  //     .then(res => res.json())
  //     .then(data => {
  //       updateUnits(data)
  //     })
  //     .catch(error => {
  //       console.error("Error fetching data:", error);
  //     })
  // }
  // }, [user])

 

  useEffect(()=> {
    if(auth?.currentUser?.emailVerified) {
      const updateEmailState = async () => {
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {emailVerified: true})
      }

      updateEmailState()
    }
  }, [auth.currentUser])

  useEffect(() => {
    const getAuthState = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuth(true)
      } else {
        setIsAuth(false)
      }
    });

    return () => getAuthState();
  }, [auth])


  useEffect(()=> {
    if(auth?.currentUser) {
      const userRef = doc(db, 'users', auth.currentUser.uid)

      const getUser = async () => {
        let data = await getDoc(userRef)
      
        dispatch(injectUser(data.data()))
        dispatch(updateProjects(data.data().projects))
      }

      getUser()
    }
  }, [isAuth, userListn])

////////////////////////////////////////////////////////////////////////////////

// const prevProjectsRef = useRef();

// const removeUndefinedFields = (obj) => {
//   if (Array.isArray(obj)) {
//     return obj.map(item => removeUndefinedFields(item));
//   } else if (obj !== null && typeof obj === 'object') {
//     return Object.fromEntries(
//       Object.entries(obj)
//         .filter(([_, v]) => v !== undefined)
//         .map(([k, v]) => [k, removeUndefinedFields(v)])
//     );
//   } else {
//     return obj;
//   }
// };


// const updateProjectsInFirestore = useCallback(
//   debounce(async (data) => {
//     if (!user?.id) return; // Check if user exists

//     try {
//       setIsUpdating(true); // Mark as updating
//       const docRef = doc(db, 'users', user.id);
//       await updateDoc(docRef, { projects: data });

//     } catch (error) {
//       console.error('Error updating Firestore:', error);
//     } finally {
//       setIsUpdating(false); // Reset updating flag
//     }
//   }, 500), // Debounce delay
//   [dispatch]
// );


// useEffect(() => {
//   const data = removeUndefinedFields(projects);

//   // Check if the current data is different from the previous projects
//   const projectsChanged = JSON.stringify(data) !== JSON.stringify(prevProjectsRef.current);

//   if (projectsChanged && !isUpdating) {
//     prevProjectsRef.current = data; // Update ref with current data
//     updateProjectsInFirestore(data); // Debounced function call
//   }
// }, [projects, dispatch]);


  ////////////////////////////////////////////////////////////////////////////////

  // Effect to set dataStructureReady when projects is an object
  // useEffect(() => {
  //   if (typeof projects === 'object' && projects !== null) {
  //     setDataStructureReady(true);
  //   }
  // }, [projects]);

  // function removeUndefinedFields(obj) {
  //   if (Array.isArray(obj)) {
  //     return obj.map(item => removeUndefinedFields(item));
  //   } else if (obj !== null && typeof obj === 'object') {
  //     return Object.fromEntries(
  //       Object.entries(obj)
  //         .filter(([_, v]) => v !== undefined)
  //         .map(([k, v]) => [k, removeUndefinedFields(v)])
  //     );
  //   } else {
  //     return obj;
  //   }
  // }

  // // Effect to update Firestore when dataStructureReady is true
  // useEffect(() => {
  //   const updateProjectsObj = async () => {
  //     // Ensure `user.id` is defined before attempting to update Firestore
  //     if (user?.id && dataStructureReady && projects) {
  //       try {
  //         let data = removeUndefinedFields(projects);
  //         // Create a document reference
  //         const docRef = doc(db, 'users', user.id);
  //         // Set the document with merge option
  //         await setDoc(docRef, { projects: data }, { merge: true });
          
  //       } catch (error) {
  //       } finally {
  //         // Reset dataStructureReady after update
  //         setDataStructureReady(false);
  //       }
  //     }
  //   };

  //   // Call the update function only when `dataStructureReady` is true
  //   if (dataStructureReady) {
  //     updateProjectsObj();
  //   }
  // }, [dataStructureReady, user?.id, projects]);

  
  ////////////////////////////////////////////////////////////////////////////////////////////////
  
  // useEffect(() => {
  //   if (typeof projects === 'object' && projects !== null) {
  //     setDataStructureReady(true);
  //   }
  // }, [projects]);

  function removeUndefinedFields(obj) {
    if (Array.isArray(obj)) {
      return obj.map(item => removeUndefinedFields(item));
    } else if (obj !== null && typeof obj === 'object') {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v !== undefined)
          .map(([k, v]) => [k, removeUndefinedFields(v)])
      );
    } else {
      return obj;
    }
  }

  // Effect to update Firestore when dataStructureReady is true
  useEffect(() => {
    const updateProjectsObj = async () => {
      // Ensure `user.id` is defined before attempting to update Firestore
      if (user?.id && projects) {
        try {
          let data = removeUndefinedFields(projects);
          // Create a document reference
          const docRef = doc(db, 'users', user.id);
          // Set the document with merge option
          await setDoc(docRef, { projects: data }, { merge: true });
          
        } catch (error) {
        } finally {
          // Reset dataStructureReady after update
          setDataStructureReady(false);
        }
      } else {
        window.alert("Else block")
      }
    };

    // Call the update function only when `dataStructureReady` is true
    if (typeof projects === 'object' && projects !== null) {
      updateProjectsObj();
    }
  }, [user?.id, projects]);

  ////////////////////////////////////////////////////////////////////////////////////////////////
  


  useEffect(()=> {
  if(user && user.sid !== null) {
    const updatePremState = async (status) => {
      if(status) await updateDoc(doc(db, 'users', user.id), {prem: status})
      if(!status) await updateDoc(doc(db, 'users', user.id), {prem: status, sid: null})
    }
    fetch(`${base}/subscription-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sid: user.sid,
        userId: user.id
      })
    }).then(res=> res.json()).then(data=> data.status === 'ACTIVE'? updatePremState(true): updatePremState(false))
  }
 }, [user])




 useEffect(()=> {
  const getToolsStates = async () => {
    let data = await getDoc(doc(db, 'management', 'toolActivation'))

    setToolsStates(data.data())
  }

  if(user) getToolsStates()
 }, [user])


 const updateIntr = async () => {
  await updateDoc(doc(db, 'users', user.id), {intr: true})
  setIntr(false)
}


 useEffect(()=> {
  if(user) {
    if(!user.intr) {
      setIntr(true)
    }
  }
 }, [user])


//  useEffect(() => {
//   const handleBackButton = () => {

//       window.location.reload();
//   };

//   window.addEventListener('popstate', handleBackButton);

//   return () => {
//       window.removeEventListener('popstate', handleBackButton);
//   };
// }, []);


useEffect(() => {
  const handleResize = () => {
    setSWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);


  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);




return (
    <Router>
      <TrackPageViews />
      {!user && cPath !== 'login' && cPath !== 'register' && cPath !== 'terms-of-use' && cPath !== 'privacy-policy' && cPath !== '' && <PageLoad />}
      {user?
      <>{cPath !== 'terms-of-use' && cPath !== 'privacy-policy' && <Header fr={forceRerender}/>}
      <AppBody>
      {bgPath !== 'ms' && <BackgroundEffect key={key}/>}
      {cPath !== 'pricing' && cPath !== 'terms-of-use' && cPath !== 'privacy-policy' && <Liquid nex={nx}/>}
      {cPath !== 'pricing' && cPath !== 'feedback' && cPath !== 'support' && cPath !== 'subscription-success' && cPath !== 's-process' && cPath !== 'p-process' && cPath !== 'payment-success' && cPath !== 'subscription-settings' && cPath !== 'terms-of-use' && cPath !== 'privacy-policy' && <Sidebar fr={forceRerender} sPathSetter={(x)=> setSettingsPath(x)} sPath={settingsPath} toolsStates={toolsStates}/>}
      {intr && <Overlay>
        <Pop>
          <div style={{display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center'}}>
          <img src={Nex20} width={260} />
          <p>As a special welcome gift, we're giving you <strong>60 free Nexilum units per month for free</strong><br/> Each unit allows you to use one of our market research tools.<br/><br/> Dive deep into data, uncover hidden insights, and elevate your growth strategies with ease.<br/> <br/>
          <br/> <br/>
          <span style={{backgroundColor: '#fdc2cb89'}}>With each tool usage, 1 Nexilum unit will be deducted from your balance</span>. Enjoy your journey into the world of market intelligence!</p> 
          </div>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', paddingLeft: '60px'}}>
          <button onClick={updateIntr}>Got it</button>

          <p style={{cursor: 'pointer'}} onClick={()=> {
              updateIntr(); 
              window.location.href = '/what-is-nexilum';
            }}>Learn more about Nexilum</p>
          </div>
        </Pop>  
      </Overlay>}
      {/* {nex === 0 && Number(user?.inuNot) === 1 && cancelInuPop && <Overlay>
        <Pop>

          <h2 className='inu_h'>Oops! You've used up all your Nexiulm units</h2>
          <img src={emptyNex} width={200}/>
          <button onClick={updateINU} className='inu_btn'>Got it</button>
        </Pop>
      </Overlay>} */}
      <Routes>
          
          <Route path='/' element={<Home nex={nex} _listn={()=> setProjListn(prev=> prev + 1)}/>} />
          
          <Route path='/pricing' element={<Upgrade />} />

          <Route path='/store' element={<Store />} />

          <Route path='/keyword-research' element={<PRoute _comp='KeywordResearch'   _toolsState={toolsStates} />} />

          <Route path='/competition-research' element={<PRoute _comp='CompetitionResearch' _listn={()=> setProjListn(prev=> prev + 1)} _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nx}/>} />

          <Route path='/trend-research' element={<PRoute _comp='TrendResearch' _listn={()=> setProjListn(prev=> prev + 1)} _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nx}/>} />

          <Route path='/google-serp' element={<PRoute _comp='GoogleSearch' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/bing-serp' element={<PRoute _comp='BingSearch' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/top-search-queries' element={<PRoute _comp='TopSearchQueries' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>} />

          <Route path='/indexed-pages' element={<PRoute _comp='IndexedPages' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>} />

          <Route path='/sitemaps' element={<PRoute _comp='Sitemaps' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/page-seo-health-test' element={<PRoute _comp='PageSEOHealthTest' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>
          
          <Route path='/crawlability-test' element={<PRoute _comp='CrawlabilityTest' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/mobile-support-test' element={<PRoute _comp='MobileSupportTest' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/headers-test' element={<PRoute _comp='HeadersTest' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/speed-test' element={<PRoute _comp='SpeedTest' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/content-ideation' element={<PRoute _comp='ContentIdeation' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>
          
          {/* <Route path='/link-analysis' element={<PRoute _comp='LinkAnalysis' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/> */}

          <Route path='/keyword-density' element={<PRoute _comp='KeywordDensity' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/extract-meta-tags' element={<PRoute _comp='ExtractMetaTags' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/high-quality-backlinks' element={<PRoute _comp='HighQualityBacklinks' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/new-backlinks' element={<PRoute _comp='NewBacklinks' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/low-quality-backlinks' element={<PRoute _comp='LowQualityBacklinks'_nex_listn={()=> setNexListn(prev=> prev + 1)}  _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/top-referrers' element={<PRoute _comp='TopReferrers' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>
          
          <Route path='/page-authority' element={<PRoute _comp='PageAuthority' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/domain-authority' element={<PRoute _comp='DomainAuthority' _nex_listn={()=> setNexListn(prev=> prev + 1)} _toolsState={toolsStates} nex={nex}/>}/>

          <Route path='/projects' element={<PRoute _comp='Projects' />} />

          <Route path='/projects/kp' element={<PRoute _comp='KeywordProject' />} />

          <Route path='/projects/srp' element={<PRoute _comp='SiteReportProject' _listn={()=> setProjListn(prev=> prev + 1)}/>} />

          <Route path='/projects/cp' element={<PRoute _comp='CompetitionProject' _listn={()=> setProjListn(prev=> prev + 1)}/>} />

          <Route path='/projects/bpp' element={<PRoute _comp='BacklinkProfileProject' _listn={()=> setProjListn(prev=> prev + 1)}/>} />

          <Route path='/projects/ci' element={<PRoute _comp='ContentIdeasProject' />} />

          <Route path='/account-settings' element={<PRoute _comp='AccountSettings' _nex={nex} _sPath={settingsPath}/>} />

          <Route path='/subscription-settings' element={<PRoute _comp='SubscriptionSettings' />} />

          <Route path='/feedback' element={<PRoute _comp='Feedback'/>} />

          <Route path='/support' element={<PRoute _comp='Support'/>} />

          <Route path='/management' element={<MRoute _comp='Management' _sPath={settingsPath}/>} />
          
          <Route path='/s-process' element={<PRoute _comp='Processing' />} />

          <Route path='/p-process' element={<PRoute _comp='PProcessing' />} />

          <Route path='/subscription-success' element={<PRoute _comp='SubscriptionSuccess' />} />

          <Route path='/payment-success' element={<PRoute _comp='PaymentSuccess' />} />

          <Route path='/verify' element={<PRoute _comp='VerifyEmail' _user_listn={()=> setUserListn(prev=> prev + 1)} />} />

          <Route path='/what-is-nexilum' element={<PRoute _comp='WhatIsNex' />} />

          <Route path='terms-of-use' element={<TermsOfUse />} />
       
          <Route path='privacy-policy' element={<PrivacyPolicy />} />

          <Route path="*" element={<Navigate to="/login" />} />

      </Routes>
      </AppBody></>:
      <>
      <Routes>
      <Route path='/' element={<Root sWidth={sWidth} auth={auth.currentUser? true: false}/>} />
      <Route path='/register' element={<Register ann={ann}/>} />
      <Route path='/login' element={<Login ann={ann}/>} />
      <Route path='/reset-password' element={<ForgotPassword />} />
      <Route path='terms-of-use' element={<TermsOfUse />} />
      <Route path='privacy-policy' element={<PrivacyPolicy />} />

      {/* <Route path="*" element={<Navigate to="/login" />} /> */}
      </Routes>
      </>}
    </Router>
  );
}

export default App;

const AppBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
  background-color: var(--ml-color);
  z-index: 10000;
`

const FadeEffect = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1020;

  opacity: 0;
  animation: ${FadeEffect} 0.8s ease-in-out forwards;
`


const Pop = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: 50%;
  background-color: #f2f2f2;
  z-index: 1050;
  border-radius: 3px;
  color: var(--ml-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
  padding: 10px 25px;
  color: #de2699;
  display: flex;
  flex-direction: column;
  gap: 20px;

  
  > div > button {
    border: none;
    border-radius: 3px;
    padding: 6px 20px;
    background-color: #de2699;
    color: white;
    transition: background-color 0.3s ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: white;
      color: #de2699;
    }
  }

  > .inu_h {
    font-weight: 300;
    font-family: 'Roboto Flex';
  }

  > .inu_btn {
    border: none;
    border-radius: 3px;
    padding: 6px 12px;
    cursor: pointer;
    background-color: #de2699;
    color: white;
    transition: color 0.3s ease-in-out;
    width: 100px;

    &:hover {
      background-color: white;
      color: #de2699;
    }
  }
  `